module.exports = __webpack_public_path__ + "img/bg222.036e4bf5.png";